import React from "react";
import { useShallow } from "zustand/react/shallow";
import { RoomState, Card, GameConstant } from "@uno/protocol";
import useStoreRoom from "../../../store/useStoreRoom";
import useStoreRoomScene from "../../../store/useStoreRoomScene";
import useStoreAnimation from "../../../store/useStoreAnimation";
import FromDeckToRoomPlayersHandsAnimation from "../../../animation/FromDeckToRoomPlayersHandsAnimation";

const useRoomStartDistribution = () => {
    const addCardToRoomScene = useStoreRoomScene(useShallow(state => state.add));
    const hasCardInRoomScene = useStoreRoomScene(useShallow(state => state.has));
    const enqueueAnimation = useStoreAnimation(useShallow(state => state.enqueue));

    return React.useCallback(() => {
        const room = useStoreRoom.getState().room;

        if(room?.state !== RoomState.Distribution) {
            throw new Error("Room state is not distribution");
        }

        const playersAroundTable = document.querySelectorAll("[data-player-id]");
        const playersCards: Map<string, Array<Card>> = new Map(room.players.map(player => [player.player.id, [...player.cards]]));

        playersAroundTable.forEach((player, playerIndex) => {
            const playerElement = player as HTMLElement;
            const playerId = playerElement.getAttribute("data-player-id") as string;
            const location = playerElement.querySelector(".cards-container") as HTMLElement;

            for(let cardIndex = 0; cardIndex < GameConstant.startingCardsCount; cardIndex++) {
                const index = playerIndex + cardIndex * playersAroundTable.length;
                const playerCards = playersCards.get(playerId) || [];
                const currentCard = playerCards.shift() as Card;

                if(!currentCard) {
                    continue;
                }

                const { initial, effects, transitions, duration, onAnimationEnd } = FromDeckToRoomPlayersHandsAnimation(location, index, playersAroundTable.length);

                if(!hasCardInRoomScene(playerId, currentCard.id)) {
                    addCardToRoomScene(playerId, index - 1, { id: currentCard.id, type: currentCard.type, canBePut: currentCard.canBePut, isHoverable: false });
                }

                enqueueAnimation(currentCard.id, { name: "from-deck-to-room-players-hands", initial, effects, transitions, duration, onAnimationEnd });
            }
        });
    }, []);
};

export default useRoomStartDistribution;
